import { Tooltip } from "@mantine/core";
import type { FC, ReactNode } from "react";

import classes from "./DataGridTruncateCell.module.scss";

type DataGridTruncateCellType = {
    tooltip: ReactNode;
    value: ReactNode;
};

const DataGridTruncateCell: FC<DataGridTruncateCellType> = ({ tooltip, value }) => (
    <Tooltip label={tooltip} withArrow>
        <span className={classes.truncate}>{value}</span>
    </Tooltip>
);

export default DataGridTruncateCell;
